'use strict';

function AddTransactionController($scope, $mdDialog, cashboxLabel) {
    'ngInject';

    $scope.cashboxLabel = cashboxLabel;

    $scope.save = function() {
        $mdDialog.hide({
            type: $scope.type,
            amount: $scope.amount,
            comments: $scope.comments
        });
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };
}

export default AddTransactionController;
